export default __webpack_public_path__ + "static/Aime-Regular-38dc7e65a11522e428de5907a781999f.woff2";